module.exports = __webpack_public_path__ + "static/shushi-be4474bcd6ced2f1ac29bfc57735e30b.jpg";